export default __webpack_public_path__ + "static/media/sidebar-2.28e8c7c7.jpg";